import React, { useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { gameActions } from '../../actions';

// Helpers
import { setupSocket, socketOn, enterBackend } from '../../helpers/sockets';

// Components
import { GameForm } from './form';
import { GameSetup } from './setup';
import { GamePlayers } from './players';
import { GameDebrief } from './debrief';
import { GameLeaderboard } from './leaderboard';

const Form = () => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();

  useEffect(() => {
    dispatch(gameActions.fetchGames(id));

    // Fetch game data to connect to socket
    fetch(process.env.REACT_APP_API_URL + '/auth/oauth_provider')
      .then((res) => res.json())
      .then((data) => {
        // Validation
        if (!data?.io_domain) return console.log('No io_domain found');
        // Connect to ws
        setupSocket(data.io_domain, null, () => {
          if (id) {
            enterBackend({ game_id: id }, (gameData) => {
              console.log(`Connected to backend ${gameData?._id}`);
            });
            // Listen to sockets
            socketOn('online_players', (online) => {
              console.log('Receiving online_players', online?.length);
              dispatch(gameActions.setData({ online }));
            });
            socketOn('player', () => {
              dispatch(gameActions.fetchGames(id));
            });
          }
        });
      });
  }, [id]);

  // LOGIC
  const SetupComponent =
    game && game.data && game.data.access_type === 'lti-hbp'
      ? GameSetup
      : GameForm;

  return (
    <div>
      {game && game.data && (
        <div style={{ minHeight: '100vh' }}>
          <Routes>
            <Route index element={<SetupComponent />} />
            <Route path='setup' element={<SetupComponent />} />
            <Route path='players' element={<GamePlayers />} />
            <Route path='debrief/overview' element={<GameDebrief />} />
            <Route path='debrief/leaderboard' element={<GameLeaderboard />} />
          </Routes>
        </div>
      )}
    </div>
  );
};

export { Form as GameItem };
